import Box from '@mui/material/Box';

import { Countries } from '@/utils/common';

import Flag from './Flags';

interface CountryFlagProps {
  country: Countries;
}

const CountryFlag = ({ country }: CountryFlagProps) => {
  if (country.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Flag width={30} height={30} country={country} />
    </Box>
  );
};

export default CountryFlag;
